import { IonNote, IonImg, IonRefresher, IonRefresherContent, useIonRouter, IonList, IonAlert, IonGrid, IonRow, IonCol, IonCardTitle, IonCardSubtitle, IonCardHeader, IonCardContent, IonAvatar, IonToast, useIonViewWillEnter, IonIcon, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { Component, useState }  from 'react';
import { RouteComponentProps } from "react-router-dom";
import { chevronForwardOutline, mailOutline, personOutline, eyeOffOutline, eyeOutline, sendOutline, listOutline, trashOutline } from "ionicons/icons";

import {Swiper, SwiperSlide } from 'swiper/react/swiper-react.js'
import { Virtual, Pagination, Navigation, Autoplay } from "swiper";

import './Main.css';

import { LANGUAGE, GetStr } from "../language/Language";
import { Storage } from '@capacitor/storage';   
import NServer, { UIElement } from "../components/NServer";
import Vault from '../components/Vault';
import { showAlert } from '../components/Alert';
import { GameInfo } from "../data/game_info";

const Games : React.FC = () => {

    const [newApps, setNewApps] = useState<GameInfo[]>([]);
    const [highlightApps, setHighlightApps] = useState<GameInfo[]>([]);
    const [allApps, setAllApps] = useState<GameInfo[]>([]);

    //	Initializing our router
	const router = useIonRouter();

    useIonViewWillEnter(() => {
        getData();
    });

    const getData = async () => {
        
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key
        }

		var server = new NServer();
        await server.getList("games", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            // update the UI
            setNewApps(server.data.new);

            setHighlightApps(server.data.highlight);

            setAllApps(server.data.all);
        }
	}

    const doRefresh = async (ev : any) => {
        await getData();

        ev.detail.complete();
    };

    return (
       <IonPage>
            <IonContent>
                <IonToolbar color="none">
                    <IonButtons slot="start">
                        <IonBackButton text="" defaultHref="/home" ></IonBackButton>
                    </IonButtons>
                    <IonTitle><h5>{ GetStr(LANGUAGE.TXT_GAMES) }</h5></IonTitle>
                </IonToolbar>
                <IonRefresher  slot="fixed" onIonRefresh={doRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>
                <IonGrid className="ion-no-padding">
                    <IonRow>
                        <IonCol className="ion-padding-start">
                            { newApps.length > 0 ? <h5>{ GetStr(LANGUAGE.TXT_GAMES_NEW) }</h5> : <div/> }
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonCard className="flat-card">
                                { newApps.map((content, index) => (
                                <IonItem className="ion-margin-top ion-margin-bottom" lines="none" key={content.id} routerLink={"/game/" + content.id}>
                                    <IonImg className="game-avt" src={content.icon} onError={ ({currentTarget}) => { currentTarget.src = "/assets/img/shop_avt.jpg" } } />
                                    <IonLabel className="ion-text-wrap ion-margin-start">
                                        <h2><b>{ content.caption }</b></h2>                
                                        <IonNote><b>{ content.descrip }</b></IonNote>
                                    </IonLabel>
                                    <IonIcon icon={chevronForwardOutline} slot="end" />
                                </IonItem>
                                ))}
                            </IonCard>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol className="ion-padding-start">
                            { highlightApps.length > 0 ? <h5>{ GetStr(LANGUAGE.TXT_GAMES_HIGHLIGHT) }</h5> : <div/> }
                        </IonCol>
                    </IonRow>
                    { /*
                    <IonRow>
                        <IonCol className="ion-padding-start">
                            { highlightApps.length > 0 ? <h5>{ GetStr(LANGUAGE.TXT_GAMES_HIGHLIGHT) }</h5> : <div/> }
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <Swiper
                                modules={[Virtual]}
                                centeredSlides={false}
                                slidesPerView={3}
                                freeMode={true}
                            >
                                {highlightApps.map((content, index) => (
                                <SwiperSlide className="swiper-tile" key={content.id} virtualIndex={index} >
                                    <IonItem className="game-tile" lines="none" color="none" routerLink={"/game/" + content.id}>
                                        <div className="but-icon">
                                            <IonImg className="game-tile-avt" src={content.icon} onError={ ({currentTarget}) => { currentTarget.src = "assets/img/shop_avt.jpg" } } />
                                            <IonLabel>
                                                { content.caption }
                                            </IonLabel>
                                        </div>
                                    </IonItem>
                                </SwiperSlide>
                                ))}
                            </Swiper>
                        </IonCol>
                    </IonRow>
                    */ }
                    <IonRow>
                        <IonCol className="ion-padding-start">
                            { allApps.length > 0 ? <h5>{ GetStr(LANGUAGE.TXT_GAMES_ALL) }</h5> : <div/> }
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonCard className="flat-card">
                                { allApps.map((content, index) => (
                                <IonItem className="ion-margin-top ion-margin-bottom" key={content.id} lines="none" routerLink={"/game/" + content.id} detail={true}>
                                    <IonImg className="game-avt-small" src={ content.icon } onError={ ({currentTarget}) => { currentTarget.src = "/assets/img/shop_avt.jpg" } } />
                                    <IonLabel className="ion-padding-start ion-text-wrap">
                                        <h2><b>{ content.caption }</b></h2>                
                                        <IonNote className="ion-text-nowrap"><i>{ content.tag }</i></IonNote>
                                    </IonLabel>
                                </IonItem>
                                ))}
                            </IonCard>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
  );
};

export default Games;
